import React, { useEffect } from 'react'
import { useFlagStore } from 'stores/flagStore'

/**
 * Zero-output component. Fetches flags for the package on mount and
 * populates the Zustand store. Mount once per page via preload_package_flags.
 *
 * @param {{ packageId: number }} props
 */
function FlagLoader({ packageId }) {
  const loadFlags = useFlagStore((s) => s.loadFlags)

  useEffect(() => {
    loadFlags(packageId)
  }, [packageId])

  return null
}

export default FlagLoader
